import {
    SET_USER_ORG,
    RESET_ORG_CREATION_STATE,
    SET_PRIMARY_ORG,
    GET_ORGS_COLLECTION,
    GET_ORGS_COLLECTION_SUCCESS,
    GET_ORGS_COLLECTION_FAILURE,
    SET_ACTIVE_USER_ORG_SUCCESS,
    SET_ACTIVE_USER_ORG_FAILURE,
    SET_SELECTED_ORG,
    UPDATE_ORG_IMAGE,
    UPDATE_ORG_IMAGE_SUCCESS,
    UPDATE_ORG_IMAGE_FAILURE,
    VALIDATE_SHORT_CODE,
    SET_SHORT_CODE_VALIDATION_RESULT,
    FETCH_ORG_EXPORT_DATA,
    WATCH_SELECTED_ORG
} from './types';

export const getOrgCollection = () => {
    return {
        type: GET_ORGS_COLLECTION
    };
};

export const getOrgCollectionFailure = error => {
    return {
        type: GET_ORGS_COLLECTION_FAILURE,
        payload: error
    };
};

export const getOrgCollectionSuccess = data => {
    return {
        type: GET_ORGS_COLLECTION_SUCCESS,
        payload: data
    };
};

export const storeOrgData = org => {
    return {
        type: SET_USER_ORG,
        payload: org
    };
};

export const resetOrgCreationState = () => {
    return {
        type: RESET_ORG_CREATION_STATE
    };
};

export const watchSelectedOrg = payload => {
    return {
        type: WATCH_SELECTED_ORG,
        payload
    };
};

export const settingSelectedOrg = org => {
    return {
        type: SET_SELECTED_ORG,
        payload: org
    };
};

export const settingPrimaryOrg = org => {
    return {
        type: SET_PRIMARY_ORG,
        payload: org
    };
};

export const settingActiveOrgSuccess = orgId => {
    return {
        type: SET_ACTIVE_USER_ORG_SUCCESS,
        payload: orgId
    };
};

export const settingActiveOrgFailure = error => {
    return {
        type: SET_ACTIVE_USER_ORG_FAILURE,
        payload: error
    };
};

export const updateOrgImage = data => {
    return {
        type: UPDATE_ORG_IMAGE,
        payload: data
    };
};

export const updateOrgImageSuccess = downloadUrl => {
    return {
        type: UPDATE_ORG_IMAGE_SUCCESS,
        payload: downloadUrl
    };
};

export const updateOrgImageFailure = error => {
    return {
        type: UPDATE_ORG_IMAGE_FAILURE,
        payload: error
    };
};

export const validateShortCode = shortCode => ({
    type: VALIDATE_SHORT_CODE,
    payload: shortCode
});

export const setShortCodeValidationResult = (isValid, errorMessage) => ({
    type: SET_SHORT_CODE_VALIDATION_RESULT,
    payload: { isValid, errorMessage }
});

export const fetchOrgCsvExportData = data => ({
    type: FETCH_ORG_EXPORT_DATA,
    payload: data
});
